export const WirelessLockGatewayInviteStates = {
  UNKNOWN: 'UNKNOWN',
  INVITE_NOT_SENT_YET: 'INVITE_NOT_SENT_YET',
  SENDING_INVITE_IN_PROGRESS: 'SENDING_INVITE_IN_PROGRESS',
  SENDING_INVITE_SUCCEEDED: 'SENDING_INVITE_SUCCEEDED',
  SENDING_INVITE_FAILED: 'SENDING_INVITE_FAILED',
  SENDING_INVITE_UNKNOWN_ERROR: 'SENDING_INVITE_UNKNOWN_ERROR',
  INVITE_ACCEPTED: 'INVITE_ACCEPTED',
};
